import React, { useEffect, useState } from 'react';
import ReactStars from 'react-rating-stars-component';
import _ from 'lodash';
import PhoneInput from 'react-phone-input-2';
import DatePicker, { registerLocale } from 'react-datepicker';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
// hooks
import useTimezoneInfo from '../../hooks/useTimezoneInfo';

// constants
import 'react-phone-input-2/lib/style.css';
import LocalStrings from '../../assets/languages';
import countryList from '../../constants/CountryCode';
import {
  CDN_URL,
  DATEPICKER_START_YEAR,
  EMOJI_RATING_OPTIONS,
  LABEL_POSITION_LEFT
} from '../../constants/constant';
import {
  commonDateFNSFormatter,
  getThumbImageUrl,
  isImage,
  isValidDate,
  parseDate
} from '../../util/util-common';

// components
import RichTextTinymceEditor from './richtext-tinymce-editor';

// files
import rightArrow from '../../assets/img/utility-icons/rightArrow.svg';
import NoImgIcon from '../../assets/img/placeholders/NoImg.svg';
import {
  eachMonthOfInterval,
  getMonth,
  getYear,
  isValid,
  parseISO
} from 'date-fns';

export const renderFieldText = field => {
  const { meta, labelPosition, label, placeholder, type } = field;
  let divClassName = `form-group row mx-0 mb-0${
    meta?.touched && meta?.error ? ' has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12 p-0';
  let inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  const fromMeeting = _.isEqual(field?.calledFrom, 'meeting');

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={`${inputClasses}`}>
        {field?.disabled ? (
          <span className="form-control input-field disabled cursor-not-allowed">
            {fromMeeting ? field?.defaultValue : field?.input?.value}
          </span>
        ) : type === 'password' ? (
          <input
            className="form-control input-field"
            type={type}
            placeholder={placeholder}
            {...field.input}
            maxLength={field.maxlength ? field.maxlength : ''}
            autoComplete="new-password"
          />
        ) : (
          <input
            className="form-control input-field"
            type={type}
            placeholder={placeholder}
            {...field.input}
            maxLength={field.maxlength ? field.maxlength : ''}
          />
        )}

        <div className="text-help">{meta?.touched ? meta?.error : ''}</div>

        {field.maxlength && !field?.disabled ? (
          <span className="char-left">
            {`${field.input.value.length}/${field.maxlength}`}
          </span>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export const renderHiddenFieldText = field => {
  let { meta } = field;
  let divClassName = `${meta.touched && meta.error ? 'has-danger' : ''}`;

  return (
    <div className={divClassName}>
      <div style={{ display: 'none' }}>
        <input className="form-control" type={field.type} {...field.input} />
      </div>
      <div className="text-help">{meta.touched ? meta.error : ''}</div>
    </div>
  );
};

export const renderPhoneNumberField = field => {
  const parts =
    !_.isNull(field?.input?.value) && typeof field?.input?.value === 'string'
      ? field?.input?.value.split(' ')
      : '';
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCode, setSelectedCode] = useState(parts[0]);
  const [phoneNumber, setPhoneNumber] = useState(parts[1]);

  const { meta, labelPosition, label } = field;

  let divClassName = `phone-number-input form-group row mx-0 mb-0${
    meta.touched && meta.error ? ' has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12 p-0';
  let inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  const handlePhoneNumberInput = (inputValue, formatData) => {
    setPhoneNumber(inputValue);
    const returnValue =
      !_.isEmpty(inputValue) && !_.isEmpty(formatData?.dialCode)
        ? `${formatData?.dialCode} ${inputValue}`
        : '';
    field?.input?.onChange(returnValue);
  };

  // Filter country list

  const filteredCountryList = _.filter(countryList, list => {
    const term = searchTerm.toLowerCase();
    return (
      list?.name?.toLocaleLowerCase().includes(term) ||
      list?.dial_code?.toLowerCase().includes(term)
    );
  });

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        {field?.disabled ? (
          <span className="form-control input-field disabled cursor-not-allowed">
            {field?.input?.value}
          </span>
        ) : (
          <div className="position-relative">
            <div className="containers">
              <div className="input-group">
                <UncontrolledDropdown direction="right">
                  <DropdownToggle className="form-control border" caret>
                    {selectedCode}
                  </DropdownToggle>
                  <DropdownMenu
                    className="scrollbar-hide-no-maxheight"
                    style={{
                      maxHeight: '300px',
                      width: '350px',
                      paddingTop: '0',
                      background: 'off-white'
                    }}
                  >
                    <div
                      className="bg-white"
                      style={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        padding: '10px',
                        borderBottom: '1px solid #ccc'
                      }}
                    >
                      <input
                        type="text"
                        placeholder={LocalStrings.dynamic.kSearchText}
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        className="form-control bg-offWhite"
                        style={{
                          width: '100%',
                          padding: '5px',
                          boxSizing: 'border-box'

                          // color: `var(--theme-dark-font-primary)`
                        }}
                      />
                    </div>
                    {_.map(filteredCountryList, (list, index) => (
                      <div key={index}>
                        <DropdownItem
                          onClick={() => {
                            setSelectedCode(list?.dial_code);
                            setSearchTerm('');
                          }}
                        >
                          {list?.emoji} {list?.dial_code} {list?.name}
                        </DropdownItem>
                        <DropdownItem divider />
                      </div>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>

                <input
                  type="number"
                  className="form-control "
                  id="phone"
                  placeholder={LocalStrings.dynamic.kPhoneNumber}
                  value={phoneNumber}
                  onChange={e =>
                    handlePhoneNumberInput(e.target.value, {
                      dialCode: selectedCode
                    })
                  }
                />
              </div>
            </div>
          </div>
        )}

        <div className="text-help">{meta.touched ? meta.error : ''}</div>

        {field.maxlength && !field?.disabled ? (
          <span className="char-left">
            {`${field.input.value.length}/${field.maxlength}`}
          </span>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export const renderFieldTextarea = field => {
  const { label, labelPosition, meta } = field;

  let divClassName = `form-group row mx-0 mb-0${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12 p-0';
  let inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses} /* style={{ position: 'relative' }} */>
        {field?.disabled ? (
          <span className="form-control textarea-field disabled cursor-not-allowed scrollbar-hide-no-maxheight">
            {field?.input?.value}
          </span>
        ) : (
          <textarea
            className="form-control textarea-field"
            placeholder={field?.placeholder}
            {...field.input}
            maxLength={field?.maxlength ? field?.maxlength : ''}
          ></textarea>
        )}
        <div className="text-help">{meta.touched ? meta.error : ''}</div>
      </div>

      {field?.maxlength && !field?.disabled ? (
        <span className="char-left">
          {`${field?.input?.value?.length}/${field?.maxlength}`}
        </span>
      ) : (
        ''
      )}
    </div>
  );
};

export const renderSelect = field => {
  const { label, labelPosition, meta } = field;

  let divClassName = `form-group row mx-0 mb-0${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12 p-0';
  let inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  let selectedValue = !_.isEmpty(field?.opts)
    ? _.find(field?.opts, opt => opt.value == field?.input?.value)
    : '';
  if (!_.isEmpty(selectedValue)) selectedValue = selectedValue.text;

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        {field?.disabled ? (
          <span className="form-control input-field disabled cursor-not-allowed">
            {selectedValue}
          </span>
        ) : (
          <select
            className="form-control input-field"
            {...field.input}
            value={field?.value}
            defaultValue={field?.supportVal}
          >
            {!_.isEmpty(field.placeholder) ? (
              <option value="" key={field.label}>
                {field.placeholder}
              </option>
            ) : (
              ''
            )}
            {!_.isEmpty(field) && !_.isEmpty(field.opts)
              ? field.opts.map((object, index) => {
                  return (
                    <option
                      key={`${object.value}-${index}`}
                      value={object.value}
                    >
                      {object.text}
                    </option>
                  );
                })
              : null}
          </select>
        )}
        <div className="text-help label-text-help">
          {meta.touched ? meta.error : ''}
        </div>
      </div>
    </div>
  );
};

export const renderSelectWOnChange = field => {
  const { label, labelPosition, meta, style } = field;

  let divClassName = `form-group row mx-0 mb-0${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12 p-0';
  let inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  let selectedValue = !_.isEmpty(field?.opts)
    ? _.find(field?.opts, opt => opt.value == field?.input?.value)
    : '';
  if (!_.isEmpty(selectedValue)) selectedValue = selectedValue.text;

  return (
    <div className={divClassName} style={style}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field?.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        {field?.disabled ? (
          <span className="form-control input-field disabled cursor-not-allowed">
            {selectedValue}
          </span>
        ) : (
          <select
            className="form-control input-field"
            {...field.input}
            onChange={e =>
              field?.callback ? field.callback(e.target.value) : null
            }
            value={field.value}
            style={field?.textStyle}
          >
            {_.has(field, 'placeholder') && (
              <option value="" key={field.label}>
                {field.placeholder}
              </option>
            )}

            {!_.isEmpty(field) && !_.isEmpty(field.opts)
              ? field.opts.map((object, index) => {
                  return (
                    <option
                      key={`${object.value}-${index}`}
                      value={object.value}
                    >
                      {object.text}
                    </option>
                  );
                })
              : null}
          </select>
        )}
        <div className="text-help label-text-help">
          {meta.touched ? meta.error : ''}
        </div>
      </div>
    </div>
  );
};

export const renderCheckbox = field => {
  const { label, opts, input, labelPosition, meta } = field;

  let divClassName = `form-group row mx-0 mb-0${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12 p-0';
  let inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        {!_.isEmpty(opts) &&
          opts.map((option, index) => {
            const fieldChecked = input.value.indexOf(option.value) !== -1;

            return (
              <div key={index}>
                <label
                  className={`custom-container-checkbox${
                    field?.disabled
                      ? `disabled disabled-input${
                          !fieldChecked ? '-notchecked' : ''
                        } `
                      : ' '
                  }custom-text1-normal mb-0`}
                >
                  {option.text}

                  {!field?.disabled ? (
                    <input
                      type="checkbox"
                      name={`${input.name}[${index}]`}
                      value={option.value}
                      checked={input.value.indexOf(option.value) !== -1}
                      onChange={event => {
                        const newValue = [...input.value];
                        if (event.target.checked) {
                          newValue.push(option.value);
                        } else {
                          newValue.splice(newValue.indexOf(option.value), 1);
                        }
                        return input.onChange(newValue);
                      }}
                      onBlur={() => input.onBlur(input.value)}
                    />
                  ) : (
                    ''
                  )}

                  <span className="checkmark" />
                </label>
              </div>
            );
          })}
        <div className="text-help">{meta.touched ? meta.error : ''}</div>
      </div>
    </div>
  );
};

export const renderFieldRadio = field => {
  const label = field?.label;
  const textIsImage =
    !_.isEmpty(label) && _.includes(label, 'eventify/') && isImage(label);
  const picUrl =
    !_.isEmpty(field?.imageUrl) && isImage(field?.imageUrl)
      ? `${CDN_URL}${getThumbImageUrl(field?.imageUrl, 'md')}`
      : textIsImage
      ? `${CDN_URL}${getThumbImageUrl(label, 'md')}`
      : '';

  return (
    <>
      <label
        className={`custom-container-radio${
          field?.disabled && !field?.isChecked
            ? ` disabled cursor-not-allowed disabled-input${
                !field?.fieldChecked ? '-notchecked' : ''
              } `
            : field?.isChecked
            ? ' checked '
            : ' '
        }custom-text1-normal mb-0${!_.isEmpty(picUrl) ? 'h-100' : ''}`}
      >
        {!_.isEmpty(picUrl) ? (
          <>
            {!textIsImage && <span>{label}</span>}

            <div
              className="d-flex h-25- w-50 justify-content-center align-items-center position-relative"
              style={{ minHeight: 50, minWidth: 50 }}
            >
              <div className="w-100 h-100" style={{ zIndex: 2 }}>
                <LazyLoadImage
                  alt={'Image'}
                  effect="blur"
                  placeholder={
                    <img
                      src={NoImgIcon}
                      className="img-responsive border-0 bg-white"
                      alt="lazy load placeholder on error"
                    />
                  }
                  className="img-responsive border-0 bg-white"
                  src={picUrl}
                  onError={e => {
                    e.target.onerror = null;
                    e.target.src = NoImgIcon;
                  }}
                />
              </div>
              <div
                className="position-absolute"
                style={{
                  zIndex: 1,
                  color: 'var(--theme-color)'
                }}
              >
                <i className={`fa fa-refresh fa-spin`}></i>
              </div>
            </div>
          </>
        ) : (
          <span className="">{label}</span>
        )}

        {!field?.disabled ? (
          <input
            type={field.type}
            {...field.input}
            disabled={field?.disabled ?? false}
          />
        ) : (
          ''
        )}

        <span className="radiomark"></span>
      </label>

      <span className="text-help label-text-help">
        {field.lastOpt && field.meta.touched ? field.meta.error : ''}
      </span>
    </>
  );
};

export const renderFieldCheckbox = field => {
  const label = field?.label;
  const textIsImage =
    !_.isEmpty(label) && _.includes(label, 'eventify/') && isImage(label);
  const picUrl =
    !_.isEmpty(field?.imageUrl) && isImage(field?.imageUrl)
      ? `${CDN_URL}${getThumbImageUrl(field?.imageUrl, 'md')}`
      : textIsImage
      ? `${CDN_URL}${getThumbImageUrl(label, 'md')}`
      : '';

  return (
    <>
      <label
        className={`custom-container-checkbox${
          field?.disabled && !field?.isChecked
            ? ` disabled cursor-not-allowed disabled-input${
                !field?.fieldChecked ? '-notchecked' : ''
              } `
            : field?.isChecked
            ? ' checked '
            : ' '
        }custom-text1-normal mb-0`}
      >
        {!_.isEmpty(picUrl) ? (
          <>
            {!textIsImage && <span>{label}</span>}

            <div
              className="d-flex w-50 justify-content-center align-items-center position-relative"
              style={{ minHeight: 80, minWidth: 80 }}
            >
              <div className="w-100 h-100" style={{ zIndex: 2 }}>
                <LazyLoadImage
                  alt={'Image'}
                  effect="blur"
                  placeholder={
                    <img
                      src={NoImgIcon}
                      className="img-responsive border-0 bg-white"
                      alt="lazy load placeholder on error"
                    />
                  }
                  className="img-responsive border-0 bg-white"
                  src={picUrl}
                  onError={e => {
                    e.target.onerror = null;
                    e.target.src = NoImgIcon;
                  }}
                />
              </div>
              <div
                className="position-absolute"
                style={{
                  zIndex: 1,
                  color: 'var(--theme-color)'
                }}
              >
                <i className={`fa fa-refresh fa-spin`}></i>
              </div>
            </div>
          </>
        ) : (
          <span className="">{label}</span>
        )}

        {!field?.disabled ? (
          <input
            type={field?.type}
            {...field.input}
            disabled={field?.disabled ?? false}
          />
        ) : (
          ''
        )}

        <span className="checkmark" />

        <span className="label-mandatory">
          {field?.mandatory === 'true' || field?.mandatory ? '*' : ''}
        </span>
      </label>

      <span className="text-help label-text-help">
        {/* {field.lastOpt && field.meta.touched ? field.meta.error : ''} */}
        {field?.meta?.touched ? field?.meta?.error : ''}
      </span>
    </>
  );
};

export const renderFieldCheckboxWithOnChange = field => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'flex-start'
      }}
    >
      <div className="custom-container-checkbox custom-text1-normal">
        <span>{field.label}</span>
        <label>
          <input
            type={field.type}
            {...field.input}
            checked={field.checked}
            onChange={field.onChange}
          />
          <span className="checkmark" onClick={field?.onClick ?? null} />
        </label>
      </div>
      {field.showDropIcon && (
        <img
          src={rightArrow}
          style={
            field.active
              ? {
                  transform: 'rotate(90deg)'
                }
              : {
                  transform: 'rotate(0deg)'
                }
          }
          className={`normal-filter`}
          alt="dropdown"
        />
      )}
    </div>
  );
};

export const renderDatePickerWithLabel = field => {
  const {
    input,
    disabled,
    label,
    labelPosition,
    displayFormat = 'P',
    placeholder = '',
    meta,
    isRange,
    settings
  } = field;

  const { rdKey, dateFnsLocale } = useTimezoneInfo();

  // Register locale once
  useEffect(() => {
    registerLocale(rdKey, dateFnsLocale);
  }, [rdKey, dateFnsLocale]);

  // Parse selectedValue depending on string or object
  let selectedValue = input?.value;
  let selectedInputValue = input?.value;
  if (typeof selectedValue === 'string') {
    if (isRange && !_.isEmpty(selectedValue) && selectedValue.includes(' - ')) {
      const [startDate, endDate] = selectedValue.split(' - ');
      selectedValue = {
        start: parseDate(startDate),
        end: parseDate(endDate)
      };
      selectedInputValue = `${
        selectedValue?.start
          ? commonDateFNSFormatter(selectedValue.start, displayFormat)
          : ''
      } - ${
        selectedValue?.end
          ? commonDateFNSFormatter(selectedValue.end, displayFormat)
          : ''
      }`;
    } else {
      selectedValue = parseDate(selectedValue);
      selectedInputValue = selectedValue
        ? commonDateFNSFormatter(selectedValue, displayFormat)
        : null;
    }
  } else if (isRange && selectedValue && typeof selectedValue === 'object') {
    selectedValue = {
      start: parseDate(selectedValue.start),
      end: parseDate(selectedValue.end)
    };
    selectedInputValue = `${
      selectedValue?.start
        ? commonDateFNSFormatter(selectedValue.start, displayFormat)
        : ''
    } - ${
      selectedValue?.end
        ? commonDateFNSFormatter(selectedValue.end, displayFormat)
        : ''
    }`;
  } else {
    selectedValue = parseDate(selectedValue);
    selectedInputValue = selectedValue
      ? commonDateFNSFormatter(selectedValue, displayFormat)
      : null;
  }

  // Compute min and max range dates from settings
  let rangeDates = { min: null, max: null };
  if (!_.isEmpty(settings)) {
    let settingVal = settings?.value || settings?.date;

    if (Array.isArray(settingVal) && typeof settingVal[0] === 'string') {
      settingVal = `${settingVal[0]} - ${settingVal[1]}`;
    }

    if (settings?.type === 'between') {
      const [startDate, endDate] = settingVal.split(' - ');
      rangeDates.min = parseDate(startDate);
      rangeDates.max = parseDate(endDate);
    } else if (settings?.type === 'after') {
      rangeDates.min = parseDate(settingVal);
    } else if (settings?.type === 'before') {
      rangeDates.max = parseDate(settingVal);
    }
  }

  // CSS classes
  const divClassName = `form-group row mx-0 mb-0${
    meta.touched && meta.error ? ' has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12 p-0';
  let inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  const handleOnChange = dates => {
    if (isRange) {
      const val = { start: dates[0], end: dates[1] };
      input.onChange(val);
    } else {
      input.onChange(dates);
    }
  };

  const _renderHeader = props => {
    const {
      date,
      changeYear,
      changeMonth,
      decreaseMonth,
      increaseMonth,
      prevMonthButtonDisabled,
      nextMonthButtonDisabled
    } = props;

    const years = _.range(DATEPICKER_START_YEAR, getYear(new Date()) + 50);
    const months = eachMonthOfInterval({
      start: new Date(getYear(new Date()), 0, 1),
      end: new Date(getYear(new Date()), 11, 1)
    }).map(d => commonDateFNSFormatter(d, 'LLL'));

    return (
      <div className="d-flex justify-content-center m-1 gap-1 form-group">
        <button
          type="button"
          className="custom-button-default-sm"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
        >
          {'<'}
        </button>
        <select
          name="datepicker-month"
          className="form-control input-field"
          value={months[getMonth(date)]}
          onChange={({ target }) => changeMonth(months.indexOf(target.value))}
        >
          {months.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <select
          name="datepicker-year"
          className="form-control input-field"
          value={getYear(date)}
          onChange={({ target }) => changeYear(Number(target.value))}
        >
          {years.map(year => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="custom-button-default-sm"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
        >
          {'>'}
        </button>
      </div>
    );
  };

  return (
    <div className={divClassName}>
      {label ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        <DatePicker
          className="form-control"
          name={input.name}
          placeholderText={placeholder}
          disabled={disabled}
          selectsRange={isRange}
          selected={!isRange ? selectedValue : null}
          startDate={isRange ? selectedValue?.start : null}
          endDate={isRange ? selectedValue?.end : null}
          minDate={rangeDates.min}
          maxDate={rangeDates.max}
          value={selectedInputValue}
          fixedHeight
          closeOnScroll
          locale={rdKey}
          dateFormat={displayFormat}
          shouldCloseOnSelect={false}
          renderCustomHeader={_renderHeader}
          onChange={handleOnChange}
        />

        <div className="text-help label-text-help">
          {meta.touched && meta.error ? meta.error : ''}
        </div>
      </div>
    </div>
  );
};

export const renderDateTimePickerWithLabel = field => {
  const {
    input,
    disabled,
    label,
    labelPosition,
    mandatory,
    selected,
    displayFormat = 'Pp',
    placeholder = '',
    meta
  } = field;

  const { rdKey, dateFnsLocale } = useTimezoneInfo();

  useEffect(() => {
    registerLocale(rdKey, dateFnsLocale);
  }, []);

  let selectedValue = input?.value ? input.value : selected ? selected : null;

  if (typeof selectedValue == 'string') {
    selectedValue = isValidDate(selectedValue) ? new Date(selectedValue) : null;
  }

  let divClassName = `form-group row mx-0 mb-0${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12 p-0';
  let inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {mandatory && mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        <DatePicker
          className="form-control"
          isClearable
          placeholderText={placeholder ?? ''}
          name={input.name}
          {...input}
          selected={selectedValue}
          showTimeSelect
          timeIntervals={10}
          timeFormat={`p`}
          dateFormat={displayFormat}
          disabled={disabled}
          onChange={input.onChange}
          locale={rdKey}
        />

        <div className="text-help label-text-help">
          {meta.touched ? meta.error : ''}
        </div>
      </div>
    </div>
  );
};

export const renderDateTimePickerForPoll = field => {
  const {
    label,
    labelPosition,
    placeholder,
    input,
    mandatory,
    disabled = false,
    meta,
    selected,
    handleOnChange = () => {}
  } = field;

  const [startDate, setStartDate] = useState(new Date());
  const [minDateTime, setMinDateTime] = useState(new Date());
  const { rdKey, dateFnsLocale } = useTimezoneInfo();

  useEffect(() => {
    registerLocale(rdKey, dateFnsLocale);

    if (selected) {
      setMinDateTime(selected);
      setStartDate(selected);
    } else {
      const currentDateTime = new Date();
      const oneHourLater = new Date(currentDateTime.getTime() + 60 * 60 * 1000);
      setMinDateTime(oneHourLater);
      setStartDate(oneHourLater);
      handleOnChange && handleOnChange(oneHourLater);
    }
  }, []);

  const handleDateChange = date => {
    setStartDate(new Date(date));

    const now = new Date();
    if (date && date.toDateString() === now.toDateString()) {
      const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);
      setMinDateTime(oneHourLater);
    }

    handleOnChange && handleOnChange(date);
  };

  const getMinTime = () => {
    const now = selected ?? new Date();
    return startDate && startDate.toDateString() === now.toDateString()
      ? new Date(now.getTime() + 60 * 60 * 1000)
      : new Date(startDate.setHours(0, 0, 0, 0));
  };

  let selectedValue = input?.value
    ? input.value
    : selected
    ? selected
    : startDate;

  if (typeof selectedValue == 'string') {
    selectedValue = new Date(selectedValue);
  }

  let divClassName = `form-group row mx-0 mb-0${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12 p-0';
  let inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {mandatory && mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        <DatePicker
          className="form-control"
          isClearable
          placeholderText={placeholder ?? ''}
          name={input.name}
          {...input}
          showTimeSelect
          timeIntervals={1}
          minDate={minDateTime}
          dateFormat={'Pp'}
          timeFormat={`p`}
          disabled={disabled}
          locale={rdKey}
          value={selectedValue}
          selected={selectedValue}
          onChange={handleDateChange}
          minTime={getMinTime()}
          maxTime={new Date().setHours(23, 59)}
        />
        <div className="text-help label-text-help">
          {meta.touched ? meta.error : ''}
        </div>
      </div>
    </div>
  );
};

export const renderHtmlInputDatePicker = field => {
  const { meta, labelPosition, label, placeholder, type } = field;

  let divClassName = `form-group row mx-0 mb-0${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12 p-0';
  let inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        <input
          className="form-control input-field"
          type="date"
          placeholder={placeholder}
          {...field.input}
        />

        <div className="text-help">{meta.touched ? meta.error : ''}</div>
      </div>
    </div>
  );
};

export const renderHtmlInputTimePicker = field => {
  const { meta, labelPosition, label, placeholder } = field;

  let divClassName = `form-group row mx-0 mb-0${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12 p-0';
  let inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div
      className={`${divClassName} d-flex align-items-center`}
      style={field.style}
    >
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses} style={{ marginBottom: 0 }}>
        <input
          onChange={e => field.callback(e.target.value)}
          className="form-control input-field"
          type="time"
          value={field.value}
          placeholder={placeholder}
          {...field.input}
        />
        <div className="text-help">{meta.touched ? meta.error : ''}</div>
      </div>
    </div>
  );
};

export const renderRichTextareaWithLabelTinymce = field => {
  const { labelPosition, label, meta } = field;

  let divClassName = `form-group row mx-0 mb-0${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12 p-0';
  let inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        <RichTextTinymceEditor type={field.type} {...field} />
        <div className="text-help label-text-help">
          {meta.error ? meta.error : ''}
        </div>
      </div>
    </div>
  );
};

export const validateEmail = email => {
  // let re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
  let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const validatePhone = phone => {
  // let re = /^[\+]?[(]?[0-9]{2,5}[)]?[-\s\.]?[0-9]{2,5}[-\s\.]?[0-9]{2,5}[-\s\.]?[0-9]{4,6}$/im;
  // let re = /^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*(\d{1,2})$/

  /**
   * Will support
   * "+12365325415"
   * "(123) 456-7890"
   * "123-456-7890"
   * "123.456.7890"
   * "2365984563"
   * "123 456 7890"
   * "123456 7890"
   * "+1 (555) 123-4567"
   * "+44 123 456 7890"
   * "(555) 1234567"
   */
  // let re = /^(\+\d{1,3}[-\s]?)?\(?\d{3}\)?[-\s.]?\d{3}[-\s.]?\d{4}$/;

  let re = /^\+\d{1,4} \d{6,14}$/;
  return re.test(phone);
};

export const validateUrl = url => {
  // let re = /^(?:(http|https):\/\/)?(?:[\w-]+\.)+[a-z]{2,6}$/;
  let re = /^(?:(?:(?:https?|http):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/;
  return re.test(url);
};

export const validateSocialURL = url => {
  let re = /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?$/;
  return re.test(url);
};

export const validateOnlyNumbers = value => {
  // return value.replace(/[^\d]/g, "");
  // let check = !isNaN(value);
  let re = /^\d+$/;
  let check = re.test(value);

  return check;
};

export const renderStarRating = field => {
  const {
    input,
    meta,
    labelPosition,
    label,
    handleChangeRating,
    color,
    selectedValue = 0
  } = field;
  let divClassName = `form-group row ${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12';
  let inputClasses = 'col-sm-12 col-sm-offset-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div
        className={`${inputClasses}${
          field?.disabled ? ' disabled cursor-not-allowed' : ''
        }`}
      >
        <ReactStars
          size={25}
          count={5}
          color={color}
          activeColor={color}
          value={selectedValue ?? 0}
          isHalf={true}
          emptyIcon={
            <i
              className="fa fa-star"
              aria-hidden="true"
              style={{ color: 'lightgray' }}
            />
          }
          halfIcon={
            <i className="fa-solid fa-star-half-stroke" aria-hidden="true" />
          }
          filledIcon={<i className="fa fa-star" />}
          onChange={newValue =>
            field?.disabled ? {} : handleChangeRating(newValue, input.name)
          }
        />
        <div className="text-help">{meta.touched ? meta.error : ''}</div>
      </div>
    </div>
  );
};

export const renderEmojiRating = field => {
  const {
    input,
    meta,
    labelPosition,
    label,
    handleChangeEmojiRating,
    emojiValues
  } = field;
  let divClassName = `form-group row ${
    meta.touched && meta.error ? 'has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12';
  let inputClasses = 'col-sm-12 col-sm-offset-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div
        className={`${inputClasses} custom-emoji-rating${
          field?.disabled ? ' disabled cursor-not-allowed' : ''
        }`}
      >
        <div className="emoji-rating-wrapper">
          {_.map(EMOJI_RATING_OPTIONS, (item, index) => {
            const isSelected = !_.isEmpty(emojiValues)
              ? _.find(
                  emojiValues,
                  ea => ea?.fieldName === input?.name && ea?.value === item
                )
              : false;

            return (
              <div
                key={`${input?.name}_${index}`}
                className={`emoji-item${isSelected ? ' selected' : ''}`}
                onClick={() =>
                  field?.disabled
                    ? {}
                    : handleChangeEmojiRating(input?.name, item)
                }
              >
                <span>{item}</span>
              </div>
            );
          })}
        </div>
        <div className="text-help">{meta.touched ? meta.error : ''}</div>
      </div>
    </div>
  );
};
